import ActiviteCell from "./ActiviteCell"

export default ({activities,isLoading}) => {
    const {Loader} = cdm_blocks.components;

    return (
        <div className={"activities-grid"} >
            
            {activities.map(activitie => {
                return <ActiviteCell activities={activitie} />
            })}
            { isLoading &&  <Loader cover="true" />}
        </div>
    )
} 